import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Card,
  Typography,
  Box,
  Button,
  Avatar,
} from "@mui/material";
import {
  FaPhone,
  FaEnvelope,
  FaUserTie,
  FaClipboardList,
  FaRegStar,
  FaCalendarAlt,
  FaTag,
} from "react-icons/fa";
import { Get_Profile_Data, reGenerateKeyApi } from "../../CommonAPI/User";
import Content from "../../../ExtraComponent/Content";
import Swal from "sweetalert2";

const ProfilePage = () => {
  const username = localStorage.getItem("name");
  const [data, setData] = useState({ loading: true, profile: {} });

  useEffect(() => {
    const getProfileData = async () => {
      try {
        const requestData = { username };
        const response = await Get_Profile_Data(requestData);

        if (response.Status) {
          localStorage.setItem("expire", 0);
          localStorage.setItem("profileData", JSON.stringify(response?.Data[0]));
          setData({ loading: false, profile: response?.Data[0] });
        } else {
          if (response.message === "Client Expired") {
            localStorage.setItem("expire", 1);
          }
          setData({ loading: false, profile: {} });
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
        setData({ loading: false, profile: {} });
      }
    };

    getProfileData();
  }, []);

  const regenerateKey = async () => {
    try {
      const data = { Username: username };
      const res = await reGenerateKeyApi(data);

      if (res.Status) {
        Swal.fire({
          icon: "success",
          title: "Pin Regenerated Successfully",
          text: "The new pin has been sent to your registered email.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to regenerate the pin. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error regenerating key:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error occurred. Please try again later.",
      });
    }
  };

  const {
    Mobile_No,
    EmailId,
    BrokerName,
    NumberofScript,
    ActivePlan,
    Strategytag,
    ServiceEndDate,
  } = data.profile;

  const infoItems = [
    { icon: <FaPhone />, label: "Phone", value: Mobile_No || "-", color: "#ff6b6b" },
    { icon: <FaEnvelope />, label: "Email", value: EmailId || "-", color: "#4dabf7" },
    { icon: <FaUserTie />, label: "Broker", value: BrokerName || "-", color: "#845ef7" },
    { icon: <FaClipboardList />, label: "Scripts", value: NumberofScript || "-", color: "#ffa94d" },
    { icon: <FaCalendarAlt />, label: "Service End Date", value: ServiceEndDate || "-", color: "#20c997" },
    {
      icon: <FaRegStar />,
      label: "Active Plan",
      value: ActivePlan?.length ? ActivePlan.join(", ") : "No Plan Available",
      color: "#fcc419",
    },
    {
      icon: <FaTag />,
      label: "Strategy Tag",
      value: Array.isArray(Strategytag) ? Strategytag.join(", ") : Strategytag || "-",
      color: "#228be6",
    },
  ];

  return (
    <Content Page_title={"👤 Profile"} button_status={false} backbutton_status={true}>
      <nav aria-label="breadcrumb">
  <ol className="breadcrumb">

    <li className="breadcrumb-item active " aria-current="page">Profile</li>
  </ol>
</nav>

     <div className="container" >
      {/* 🔹 Header Section */}
      <div
        className="card mb-5 p-4 d-flex justify-content-between align-items-center flex-row"
        style={{
          borderRadius: "1rem",
        
          color: "white",
          backdropFilter: "blur(10px)",
          boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
        }}
      >
        <div className="d-flex align-items-center gap-3">
          <div
            className="d-flex align-items-center justify-content-center rounded-circle"
            style={{
              backgroundColor: "white",
              color: "#1976d2",
              fontWeight: "bold",
              width: "60px",
              height: "60px",
              fontSize: "24px",
            }}
          >
            {username?.charAt(0)?.toUpperCase()}
          </div>
          <div>
            <h5 className="mb-1 fw-bold">{username}</h5>
            <p className="mb-0" style={{ opacity: 0.8 }}>
              Your personal profile details
            </p>
          </div>
        </div>
        {/* <button
          className="btn btn-light fw-bold"
          style={{ color: "#1976d2", borderRadius: "30px", padding: "0.25rem 1.5rem" }}
          onClick={regenerateKey}
        >
          Re-Generate Key
        </button> */}
      </div>

      {/* 🔹 Info Grid */}
      <div className="row g-3">
        {infoItems.map((item, index) => (
          <div className="col-12 col-sm-6 col-md-4" key={index}>
            <div
              className="card p-3 d-flex align-items-center gap-2 h-100 flex-row"
              style={{
                borderRadius: "1rem",
                boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
              }}
            >
              <div
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: "45px",
                  height: "45px",
                  padding: "12px",
                  backgroundColor: item.color,
                  color: "white",
                  fontSize: "22px",
                }}
              >
                {item.icon}
              </div>
              <div>
                <p className="mb-1 fw-bold text-muted">{item.label}</p>
                <p className="mb-0 fw-medium">{item.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    </Content>
  );
};

export default ProfilePage;
